import { useDispatch } from 'react-redux';
import { subscribeNewsletter } from '@client/newsletter/redux/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export function useNewsletterSubscriptionAction(): typeof subscribeNewsletter {
  const dispatch = useDispatch();

  return bindActionCreators(subscribeNewsletter, dispatch);
}
